module.exports = __webpack_public_path__ + "assets/img/07-class-loader.7716eab7.png";